export const useUserAgent = () => (import.meta.server ? useRequestHeader('user-agent') : navigator.userAgent);
